import {Component, Inject, LOCALE_ID} from '@angular/core';
import {formatPrivacyPolicyVersion, PRIVACY_POLICY_VERSION} from './privacy-policy-version';


@Component({
  selector: 'app-privacy-policy-content',
  templateUrl: './privacy-policy-content.component.html',
  styleUrls: ['./privacy-policy-content.component.scss']
})
export class PrivacyPolicyContentComponent {

  constructor(
    @Inject(LOCALE_ID) private locale: string,
  ) { }

  get versionLabel(): string | null {
    return formatPrivacyPolicyVersion(PRIVACY_POLICY_VERSION, this.locale);
  }
}
